<!-- <div class="progress-modal">
  <div class="progress-modal__content">
    <div class="progress-modal__header">
      <div class="progress-modal__spinner" *ngIf="showSpinner">
        <div class="spinner">
          <span class="spinner-text">Fra...</span>
          <div class="spinner-loader"></div>
        </div>
      </div>
      <button class="progress-modal__close" *ngIf="showCloseButton" (click)="onCloseClick()">X</button>
    </div>

    <div class="progress-modal__message">{{ message }}</div>

    <div class="progress-modal__bar" *ngIf="showProgressBar">
      <div class="progress-modal__bar-fill" [style.width.%]="progress"></div>
    </div>

    <button class="progress-modal__stop" *ngIf="showStopButton" (click)="onStopClick()">Parar</button>
  </div>
</div> -->

<div class="progress-modal">
  <div class="progress-modal__content">
    <div class="progress-modal__header">
      <div class="progress-modal__spinner" *ngIf="showSpinner">
        <div class="spinner">
          <div [class]="spinning ? 'spinner-loader':'stop'"></div>
        </div>
      </div>

      <button class="progress-modal__close" (click)="onCloseClick()" *ngIf="showCloseButton">
        <ion-icon name="close-circle"></ion-icon>
      </button>
    </div>

    <div class="progress-modal__message" *ngIf="errorMessage.length == 0 && successMessage.length == 0">{{ message }}</div>

    <div class="progress-modal__bar" *ngIf="showProgressBar">
      <div class="progress-modal__bar-fill" [style.width.%]="progress"></div>
    </div>

    <div class="progress-modal__success" *ngIf="successMessage.length > 0">
      <ion-icon name="checkmark-circle"></ion-icon>
      <p class="progress-modal__success__text">{{successMessage}}</p>
    </div>

    <div class="progress-modal__error" *ngIf="errorMessage.length > 1">
      <ion-icon name="warning"></ion-icon>
      <p class="progress-modal__error__text">{{errorMessage}}</p>
    </div>

    <div class="progress-modal__bottom" *ngIf="showRestartButton"><button class="progress-modal__stop button" (click)="onRestartClick()">{{ 'BUTTONS.RESTART' | translate }}</button></div>
    <div class="progress-modal__bottom" *ngIf="showStopButton"><button class="progress-modal__stop button" (click)="onStopClick()">{{ 'BUTTONS.STOP' | translate }}</button></div>
    <div class="progress-modal__bottom" *ngIf="showContinueButton"><button class="progress-modal__stop button" (click)="onContinueClick()">{{ 'BUTTONS.CONTINUE' | translate }}</button></div>
  </div>
</div>
